import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.values.js";
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import store from '@/store';
import { USER_DELETE, USER_LIST, USER_UPDATE } from '@/store/actions/user';
import { generateRandomString } from '@/utils/util';
import UserItem from '@/components/users/UserItem.vue';
import UserRightManagement from '@/components/users/UserRightManagement.vue';
import PasswordNotificationDialog from "@/components/dialog/PasswordNotificationDialog.vue";
import StandardNotificationDialog from "@/components/dialog/StandardNotificationDialog.vue";
import UserAccountDeleteDialog from "@/components/dialog/UserAccountDeleteDialog.vue";
var UsersTable = /*#__PURE__*/function (_Vue) {
  function UsersTable() {
    var _this;
    _classCallCheck(this, UsersTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, UsersTable, [].concat(args));
    _defineProperty(_this, "toggleUserPwdResetDialog", false);
    _defineProperty(_this, "toggleAccountDeleteDialog", false);
    _defineProperty(_this, "errorMsg", '');
    _defineProperty(_this, "loading", false);
    _defineProperty(_this, "sidePanelVisible", false);
    _defineProperty(_this, "selectedUser", null);
    _defineProperty(_this, "passwordRequestedFor", null);
    _defineProperty(_this, "ressettedPasswordUrl", null);
    _defineProperty(_this, "userToDelete", null);
    return _this;
  }
  _inherits(UsersTable, _Vue);
  return _createClass(UsersTable, [{
    key: "users",
    get: function get() {
      return Object.values(store.getters.users);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.loadListUser();
    }
  }, {
    key: "isUserDeleteAivailable",
    get: function get() {
      return store.getters.isDeleteUserAvailable;
    }
  }, {
    key: "loadListUser",
    value: function loadListUser() {
      var _this2 = this;
      this.errorMsg = '';
      this.loading = true;
      store.dispatch(USER_LIST).then(function () {
        _this2.loading = false;
        _this2.errorMsg = '';
      }).catch(function (err) {
        _this2.loading = false;
        _this2.errorMsg = err;
      });
    }
  }, {
    key: "resetPassword",
    value: function resetPassword(user) {
      var _this3 = this;
      this.passwordRequestedFor = user;
      this.ressettedPasswordUrl = null;
      var tmpPassword = generateRandomString(30);
      this.errorMsg = '';
      this.loading = true;
      store.dispatch(USER_UPDATE, {
        user: user,
        tmpPassword: tmpPassword
      }).then(function () {
        _this3.informPassword(user, tmpPassword);
        _this3.loading = false;
        _this3.errorMsg = '';
      }).catch(function (err) {
        _this3.loading = false;
        _this3.errorMsg = err;
      });
    }
  }, {
    key: "informPassword",
    value: function informPassword(user, tmpPassword) {
      this.ressettedPasswordUrl = document.location.origin + '/update/' + user.login + '/' + tmpPassword;
      this.toggleUserPwdResetDialog = true;
    }
  }, {
    key: "deleteUser",
    value: function deleteUser(user) {
      this.userToDelete = user;
      this.toggleAccountDeleteDialog = true;
    }
  }, {
    key: "confirmAccountDelete",
    value: function confirmAccountDelete() {
      var _this4 = this;
      this.toggleAccountDeleteDialog = false;
      this.errorMsg = '';
      this.loading = true;
      store.dispatch(USER_DELETE, this.userToDelete).then(function () {
        _this4.loading = false;
        _this4.errorMsg = '';
      }).catch(function (err) {
        _this4.loading = false;
        _this4.errorMsg = err;
      });
    }
  }, {
    key: "selectUser",
    value: function selectUser(user) {
      this.selectedUser = user;
      this.sidePanelVisible = true;
    }
  }, {
    key: "closeSidePanel",
    value: function closeSidePanel() {
      this.sidePanelVisible = false;
    }
  }]);
}(Vue);
UsersTable = __decorate([Options({
  components: {
    UserRightManagement: UserRightManagement,
    UserItem: UserItem,
    StandardNotificationDialog: StandardNotificationDialog,
    PasswordNotificationDialog: PasswordNotificationDialog,
    UserAccountDeleteDialog: UserAccountDeleteDialog
  }
})], UsersTable);
export default UsersTable;